module.exports = "app-material-servico-table {\n    width: 100%;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/almoxarifado/materiais/material-servico/material-servico-form-list/material-servico-form-list.component.css
 ** module id = 1004
 ** module chunks = 0
 **/